import { OwnerMemberCreateSchema } from '#web-service-api/member';
import { CommonInvitationCreateSchema } from './common-invitation-create.schema';
export const OwnerInvitationCreateSchema = CommonInvitationCreateSchema.extend({
    owner: OwnerMemberCreateSchema,
});
